const PlusIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="circle-plus"
          d="M13.875 9.375H10.75V6.25C10.75 5.90453 10.4705 5.625 10.125 5.625C9.77953 5.625 9.5 5.90625 9.5 6.25V9.375H6.375C6.03125 9.375 5.75 9.65625 5.75 10C5.75 10.3438 6.03125 10.625 6.375 10.625H9.5V13.75C9.5 14.0955 9.77953 14.375 10.125 14.375C10.4705 14.375 10.75 14.0955 10.75 13.75V10.625H13.875C14.2205 10.625 14.5 10.3455 14.5 10C14.5 9.65453 14.2188 9.375 13.875 9.375Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default PlusIcon;
